export const getBaseUrl = (url: string) => `${process.env.BE_URL}${url}`;
